import { IParams } from '../params';

export const commercialCoworkingParams: (keyof IParams)[] = [
  'coworkingPublishPeriod',
  'undergroundTime',
  'amenities',
  'floor',
  'floorsTotal',
  'coworkingAccess',
  'wordsInclude',
  'wordsExclude',
  'phone',
  'offerId',
];
